import React, { useContext, useEffect, useRef } from 'react';

// MUI
import { styled } from '@mui/material/styles';

// OpenLayers
import OlControl from 'ol/control/Control';
import OlBaseLayer from 'ol/layer/Base';
import { Map } from 'ol';

// Custom components
import BaseLayerSwitcherClass from '../BaseLayerSwitcher/baseLayerSwitcherClass';
import BaseLayerTreeUI from './BaseLayerTreeUI';
import MapContext, { MapContextType } from '@/context/MapContext/MapContext';
import { findControl, getDefinedOptions, getEvents } from '@/lib/olHelpers';
import makeMUIControlStyle from '@/components/Map/Controls/makeMUIControlStyle';

export interface BaseLayerTreeControlProps {
  mapId?: number;
  layers: Array<OlBaseLayer>;
}

const BaseLayerTreeControl = (props: BaseLayerTreeControlProps) => {
  const mapContext = useContext(MapContext) as MapContextType;

  const { layers, mapId } = props;

  const id = 'base-layer-switcher';

  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const mapControl = findControl(mapContext.map as Map, id, BaseLayerSwitcherClass);

    if (!mapControl && elementRef.current) {
      const options = {
        element: elementRef.current,
        target: undefined,
      };

      const allOptions = {};
      Object.assign(allOptions, options, props);
      const definedOptions = getDefinedOptions(allOptions);

      const events = {};

      const control = new BaseLayerSwitcherClass(definedOptions);
      control.set('id', id);

      const olEvents = getEvents(events, props);
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const eventName in olEvents) {
        // @ts-ignore TODO:  Argument of type 'string' is not assignable to parameter of type '("error" | "change" | "propertychange")[]'
        control.on(eventName, olEvents[eventName]);
      }

      mapContext.initOptions.controls.push(control as OlControl);
    }
  }, []);

  return <BaseLayerTreeUI mapId={mapId} layers={layers} />;
};

const StyledBaseLayerTreeControl = styled(BaseLayerTreeControl)(({ theme }) => {
  const styles = makeMUIControlStyle(theme);
  return {
    ...styles.control,
  };
});

export default StyledBaseLayerTreeControl;
